import type { StatementView } from '@/api/tmm/types';

/**
 * What a person copies for support (TMMPDM-0072, TMMPDM-0075): the statement's identifiers and the
 * raw `lastError`, which is only ever copied, never shown (TMM-B3). English `key: value` lines
 * whatever the locale; an unsent value is `-`. Shared by the billing-attention panel and a tenant's
 * Statements tab.
 */
export function statementSupportDetails(row: StatementView): string {
  const value = (v: string | number | undefined) => (v === undefined || v === '' ? '-' : String(v));
  return [
    `statementId: ${row.id}`,
    `period: ${row.periodStart} to ${row.periodEnd}`,
    `chargeStatus: ${row.chargeStatus}`,
    `attempts: ${row.attempts}`,
    `lastAttemptAt: ${value(row.lastAttemptAt)}`,
    `lastError: ${value(row.lastError)}`,
  ].join('\n');
}
